module.exports = __webpack_public_path__ + "static/media/costa_rica.b597553b.png";